var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.588 5.487c-3.597-4.19-9.91-4.672-14.1-1.075-4.191 3.597-4.673 9.91-1.077 14.1A10 10 0 0 0 21.35 8.455L9.808 19.997a1.672 1.672 0 0 1-2.848-1.182V9.89a1.672 1.672 0 0 1 3.343-.04v4.92z"
  })));
};
export default SvgVerified;